import { Box } from '@mui/material';
import { InsuredEntityPageContainer } from './insured-entity.page.container';
import { NewConvergeButton } from '../../../presentation';
import { useConvergeSnackBar } from '../../../contexts';
import { useInsuredEntityQuery } from '@converge/graphql';

export const InsuredDocumentDetails = () => {
  const extractInsuredUuidFromUrl = (
    url: string = window.location.pathname
  ): string => {
    const match = url.match(/\/insureds\/([^/]+)/);
    return match ? match[1] : '';
  };
  const insuredUuid = extractInsuredUuidFromUrl();

  const { data: insuredData, loading: documentsLinkLoading } =
    useInsuredEntityQuery(insuredUuid);
  const { notify } = useConvergeSnackBar();

  const handleDocumentClick = () => {
    if (insuredData?.entities?.edges[0]?.node?.documentLink) {
      window.open(insuredData.entities.edges[0].node.documentLink, '_blank');
    } else {
      notify('There is no document folder for this insured', {
        variant: 'error',
      });
    }
  };

  return (
    <>
      <InsuredEntityPageContainer
        title="Documents"
        titleChildren={
          <Box style={{ backgroundColor: 'white' }}>
            <Box>Access all of the documents associated with this insured.</Box>
          </Box>
        }
      >
        <Box style={{ marginLeft: '20px', marginTop: '40px', width: '170px' }}>
          <NewConvergeButton
            onClick={handleDocumentClick}
            data-cy="insured-documents-button"
            label={'VIEW DOCUMENTS'}
            loading={documentsLinkLoading}
          />
        </Box>
      </InsuredEntityPageContainer>
    </>
  );
};
